import PageHero from "../components/PageHero";
import GalleryGrid from "../components/GalleryGrid";

export default function Seara() {
  const IMAGINI = [1, 2, 3, 4, 5].map(n => `/images/seara/${n}.png`);

  return (
    <section>
      <PageHero title="Rochii de seară" subtitle="Materiale fluide, linii elegante, finisaje impecabile." />
      <GalleryGrid items={IMAGINI} />
    </section>
  );
}
